import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ colors, border, spacing }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 380px;
    padding: ${spacing.md};
    border-radius: ${border.radius.lg};
    background-color: ${colors.background.white};
    box-sizing: border-box;

    > p {
      margin: ${spacing.xxs} 0 ${spacing.sm};
      color: ${colors.neutral[400]};
    }
  `,

  buttonWrapper: ({ spacing }) => css`
    margin-top: ${spacing.xs};
  `,

  linkWrapper: ({ spacing }) => css`
    margin-top: ${spacing.xs};
    text-align: center;
    cursor: pointer;
  `,

  LinkSupport: ({ colors, spacing }) => css`
    position: relative;
    color: ${colors.background.white};
    margin: ${spacing.xs} 0;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      margin: ${spacing.md};
    }

    &:hover {
      color: ${colors.background.white};
    }
  `,
})

export default useStyles
